/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
} from './Organization';

/**
 * 
 * @export
 * @interface OrganizationDetailsAllOf
 */
export interface OrganizationDetailsAllOf {
    /**
     * 
     * @type {Array<Organization>}
     * @memberof OrganizationDetailsAllOf
     */
    managed_organizations?: Array<Organization>;
}

/**
 * Check if a given object implements the OrganizationDetailsAllOf interface.
 */
export function instanceOfOrganizationDetailsAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OrganizationDetailsAllOfFromJSON(json: any): OrganizationDetailsAllOf {
    return OrganizationDetailsAllOfFromJSONTyped(json, false);
}

export function OrganizationDetailsAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationDetailsAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'managed_organizations': !exists(json, 'managed_organizations') ? undefined : ((json['managed_organizations'] as Array<any>).map(OrganizationFromJSON)),
    };
}

export function OrganizationDetailsAllOfToJSON(value?: OrganizationDetailsAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'managed_organizations': value.managed_organizations === undefined ? undefined : ((value.managed_organizations as Array<any>).map(OrganizationToJSON)),
    };
}

